import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import {
  LP,
  MLP,
  NameInitials,
  NumberRound,
  USDT,
  formatUSD
} from '../../helpers/helperFunctions';

import { useWindowWide } from '../../helpers/wideScreen';
import { CaptionText, H1, H2, H3, P1, P2, P3 } from '../../styles/FontStyles';
import {
  Box,
  Flexed,
  ProfileImage,
  ProfileImagePlaceholder,
  ProfilePicture
} from '../../styles/GlobalComponents';
import { colors } from '../../styles/GlobalStyles';
import { Flex, Responsive } from '../../styles/stylesStyled';

import {
  EARNINGS,
  ENTRY_PACKAGE,
  MARKETPLACE,
  MY_HUBS,
  MY_TEAM,
  ORDERS,
  RANKING,
  SETTINGS_ACCOUNT,
  SETTINGS_PAYMENTS,
  SETTINGS_SECURITY,
  SUPPORT_TICKETS
} from '../../routes/routes';
import { User } from '../../types/loginTypes';
import { DashboardInformation } from './Dashboard.types';
import { useAppSelector } from '../../app/hooks';
import { Button } from '../../components';
import { Link } from 'react-router-dom';

interface EarningsComponentProps {
  user: User;
  backOffice: DashboardInformation | null;
}

export const EarningsComponent2 = ({
  user,
  backOffice
}: EarningsComponentProps) => {
  const { t } = useTranslation('dashboard');

  const wide = useWindowWide(800);

  const { username } = useAppSelector((state) => state.auth.userInfo.user);

  return (
    <Box
      style={{ width: '100%', marginBottom: 0 }}
      p='46px 36px'
      pSM='46px 36px'
      mSM='0'
      mbSM='0'>
      <div>
        <Flexed gap='10px' center mb='30'>
          <ProfilePicture size={wide ? '70px' : '64px'}>
            {user?.profileImageUrl ? (
              <ProfileImage src={user?.profileImageUrl} alt='Upload' />
            ) : (
              <ProfileImagePlaceholder
                size={window.innerWidth > 800 ? '70px' : '64px'}
                font={window.innerWidth > 800 ? '24px' : '20px'}>
                {NameInitials()}
              </ProfileImagePlaceholder>
            )}
          </ProfilePicture>
          <div>
            <P1 color={colors.primary900}>Welcome back,</P1>
            <P1 bold color={colors.primary900}>
              {username}
            </P1>
          </div>
        </Flexed>
        <div>
          <Link to={MY_TEAM}>
            <Box border>
              <H3 color={colors.primary900}>My Organization</H3>
              <P3 color={colors.neutral700}>Edit your organization</P3>
            </Box>
          </Link>
          <Link to={EARNINGS}>
            <Box border>
              <H3 color={colors.primary900}>Earnings</H3>
              <P3 color={colors.neutral700}>User Earnings</P3>
            </Box>
          </Link>

          <Link to={ENTRY_PACKAGE}>
            <Box border>
              <H3 color={colors.primary900}>Entry Packages</H3>
              <P3 color={colors.neutral700}>Entry Packages</P3>
            </Box>
          </Link>

          <Link to={MY_HUBS}>
            <Box border>
              <H3 color={colors.primary900}>My Hubs</H3>
              <P3 color={colors.neutral700}>User Hubs</P3>
            </Box>
          </Link>

          <Link to={ORDERS}>
            <Box border>
              <H3 color={colors.primary900}>Orders</H3>
              <P3 color={colors.neutral700}>User Orders</P3>
            </Box>
          </Link>

          <Link to={RANKING}>
            <Box border>
              <H3 color={colors.primary900}>Ranking</H3>
              <P3 color={colors.neutral700}>User Rankings</P3>
            </Box>
          </Link>

          <Link to={SETTINGS_ACCOUNT}>
            <Box border>
              <H3 color={colors.primary900}>Settings</H3>
              <P3 color={colors.neutral700}>User Settings</P3>
            </Box>
          </Link>

          <Link to={SUPPORT_TICKETS}>
            <Box border mb='0'>
              <H3 color={colors.primary900}>Support</H3>
              <P3 color={colors.neutral700}>Support Tickets</P3>
            </Box>
          </Link>
        </div>
        {/* <div>
          <Box br='30px'>
            <Flexed between>
              <Flex style={{ flexWrap: 'wrap' }}>
                <div style={{ marginRight: 50 }}>
                  <P3 color={colors.neutral500}>
                    {t('earnings.total_earnings')}
                  </P3>
                  <H3 bold mb='4'>
                    {backOffice &&
                      formatUSD(
                        NumberRound(backOffice?.user?.totalEarnings)
                      )}{' '}
                    {USDT}
                  </H3>
                  {backOffice && (
                    <P3 flex color={colors.neutral500}>
                      <P3 color={colors.success500} mr='5' bold>
                        {backOffice?.user?.currentWeekEarnings > -1 && '+'}
                        {formatUSD(
                          NumberRound(backOffice?.user?.currentWeekEarnings)
                        )}{' '}
                        {USDT}{' '}
                      </P3>
                      {t('earnings.this_week')}
                    </P3>
                  )}
                </div>
              </Flex>
            </Flexed>
          </Box>
          <Box br='30px'>
            <Flexed column onClick={() => history.push(EARNINGS)}>
              <P3 pointer color={colors.neutral500}>
                Cash Account balance
              </P3>
              <H3 pointer>
                {formatUSD(
                  backOffice?.user?.userTickets?.availableRewardPoints
                )}{' '}
                {USDT}
              </H3>
            </Flexed>
          </Box>

          <Box br='30px'>
            <Flexed column onClick={() => history.push(EARNINGS)}>
              <P3 pointer color={colors.neutral500}>
                Travel Account balance
              </P3>
              <H3 pointer>
                {formatUSD(backOffice?.user?.userTickets?.shoppingPoints)}{' '}
                {USDT}
              </H3>
            </Flexed>
          </Box>

          {backOffice?.user?.userTickets?.myLifePoints &&
          backOffice?.user?.userTickets?.myLifePoints > 0 ? (
            <Box br='30px' m='0'>
              <Flexed column onClick={() => history.push(EARNINGS)}>
                <P3 pointer color={colors.neutral500}>
                  {t('earnings.mlp_points')}
                </P3>
                <H3 pointer>
                  {formatUSD(backOffice?.user?.userTickets?.myLifePoints)} {MLP}
                </H3>
              </Flexed>
            </Box>
          ) : null}
        </div> */}
      </div>
    </Box>
  );
};
